import { differenceInCalendarDays } from 'date-fns'

import type { EnterpriseMemberDetailResponse } from '@/api/teamMembersTable'

const RECENT_DAYS = 14
const MEANINGFUL_WORDS = 1000

type MemberUsage = Pick<EnterpriseMemberDetailResponse, 'lastUsedAt' | 'totalWords' | 'joinedAt'>

const daysSince = (unixSeconds: number, now: Date) => differenceInCalendarDays(now, new Date(unixSeconds * 1000))

const relative = (days: number) => {
  if (days <= 0) return 'today'
  if (days === 1) return 'yesterday'
  return `${days} days ago`
}

// Shown in the remove-member confirmation so admins see what the person gets from
// Flow before cutting the seat. Picks the most compelling true statement, or nothing.
export function getRemovalUsageLine(member: MemberUsage, now: Date = new Date()): string | null {
  const lastUsedDays = member.lastUsedAt === null ? null : daysSince(member.lastUsedAt, now)
  const usedRecently = lastUsedDays !== null && lastUsedDays < RECENT_DAYS
  const words = member.totalWords >= MEANINGFUL_WORDS ? member.totalWords.toLocaleString() : null

  if (usedRecently && words) return `They last used Flow ${relative(lastUsedDays)} and have dictated ${words} words.`
  if (usedRecently) return `They last used Flow ${relative(lastUsedDays)}.`
  if (words) return `They have dictated ${words} words with Flow.`

  const joinedDays = member.joinedAt === null ? null : daysSince(member.joinedAt, now)
  if (joinedDays !== null && joinedDays < RECENT_DAYS) return `They joined ${relative(joinedDays)}.`

  return null
}
